
import Vue from "vue";

export default Vue.extend({
  props: {
    context: { type: Object, required: true },
    images: { type: Object, required: true },
    isCn: { type: Boolean, required: true },
    phone: { type: String, required: true },
    code: { type: String, required: true },
    email: { type: String, required: true },
    password: { type: String, required: true },
    error: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    time: { type: Number, default: 0 },
    phoneHelp: { type: String, default: "" },
    emailHelp: { type: String, default: "" },
    canSendCode: { type: Boolean, default: false },
    canPhoneSignIn: { type: Boolean, default: false },
    canEmailSignIn: { type: Boolean, default: false },
  },
  computed: {
    sendText(): string {
      return this.time
        ? `${this.time}${this.$t("resend")}`
        : `${this.$t("sendCode")}`;
    },
  },
  methods: {
    update(field: "phone" | "code" | "email" | "password", value: string) {
      this.$emit(`update:${field}`, value);
    },
  },
});
